<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="searchForm" :inline="true" size="mini" label-width="80px">
          <el-form-item label="报告名称" prop="fileName">
            <el-input v-model="searchForm.fileName" placeholder="请输入报告名称"></el-input>
          </el-form-item>
          <el-form-item label="上市时间">
            <form-date-range :form="searchForm" startKey="createdDateStart" :usingTime="false" endKey="createdDateEnd" valueFormat="yyyy-MM-dd">
            </form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="onReset">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="onExport">导出</el-button>
        <el-button type="primary" size="mini" @click="isShowLog = true">操作日志</el-button>
        <el-button type="primary" size="mini" @click="onImport" v-permission="`ec-pc-new$goodsManage$basicInformationManagement$productTestingReport$Import`">报告导入</el-button>
      </template>
      <el-table
        border
        stripe
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        :data="tableData.records"
        :height="maxTableHeight"
        v-loading="loading"
      >
        <el-table-column label="序号" prop="seqNum" width="60"> </el-table-column>
        <el-table-column label="报告名称" prop="fileName"> </el-table-column>
        <el-table-column label="质检时间" prop="qualityDate" width="160"> </el-table-column>
        <el-table-column label="上传人" prop="createdByName" width="90"> </el-table-column>
        <el-table-column label="上传时间" prop="createdDate" width="160"> </el-table-column>
        <el-table-column label="操作" width="170" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="onEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" @click="onPreview(scope.row)">预览</el-button>
            <el-button type="text" size="mini" @click="onDownload(scope.row)">下载</el-button>
            <el-button
              type="text"
              size="mini"
              @click="onDel(scope.row)"
              class="red-text-btn"
              v-permission="`ec-pc-new$goodsManage$basicInformationManagement$productTestingReport$Del`"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>
    <!-- 操作日志 -->
    <operationLog :visible.sync="isShowLog" v-if="isShowLog" />
    <!-- 编辑 -->
    <editDialog :visible.sync="isShowEdit" :rowData="rowData" v-if="isShowEdit" @success="onSearch"/>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import moment from 'moment';
import operationLog from './operation-log.vue';
import editDialog from './edit.vue'
import tableMixin from '@/utils/tableMixin';
export default {
  name: 'CommoditySales',
  mixins: [tableMixin, pagePathMixin],
  components: { operationLog, editDialog },
  data() {
    return {
      loading: false,
      loading2: false,
      imgFormVisible: false,
      isShowOmparison: false,
      isShowLog: false,
      isShowEdit: false,
      searchForm: {
        fileName: '',
        createdDateStart: '',
        createdDateEnd: '',
      },
      tableData: {
        records: [],
        pageSize: 30,
        pageNum: 1,
        total: 0,
      },
      exportData: {},
      searchFormData: {},
      rowData: {},
      columnsData: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    onReset() {
      this.searchForm = {
        fileName: '',
        createdDateStart: '',
        createdDateEnd: '',
        queryType: 2,
      };
      this.onSearch();
    },
    init() {
      this.loading = true;
      let data = {
        filterData: {
          ...this.searchForm,
          queryType: 2,
          taskType: 1,
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        exportTag: false,
      };
      this.searchFormData = data;
      this.$q.product
        .fileTaskListPage({ data: data })
        .then((res) => {
          this.tableData = res.data;
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(1);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(1);
    },
    onEdit(row) {
      this.rowData = {...row}
      this.isShowEdit = true
    },
    onPreview(row) {
      if (row.fileName.includes('.docx')) {
        var targetUrl = this.$router.resolve({
          path: '/previewDocx',
          query: { wordURL: row.filePath },
        }).href;
      } else {
        var targetUrl = this.$router.resolve({
          path: '/previewPdf',
          query: { pdfUrl: row.filePath },
        }).href;
      }
      window.open(targetUrl, '_blank');
    },
    onDownload(row) {
      this.downLoad(row.filePath, row.fileName);
    },
    downLoad(path, name) {
      let url = path;
      let fileName = name;
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        if (xhr.status === 200) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(xhr.response, fileName);
          } else {
            var link = document.createElement('a');
            var body = document.querySelector('body');

            link.href = window.URL.createObjectURL(xhr.response);
            link.download = fileName;

            // fix Firefox
            link.style.display = 'none';
            body.appendChild(link);

            link.click();
            body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          }
        }
      };
      xhr.send();
    },
    async onDel(row) {
      console.log(row.taskId);
      let status = await this.$confirm('是否确认删除该条数据？', '提示', { type: 'warning' });
      if (status !== 'confirm') return;
      let res = await this.$q.product.fileTaskDelete({ fragment: [row.taskId] });
      if (res.success) {
        this.$message.success('删除成功');
      } else {
        this.$message.fail('删除失败');
      }
      this.onSearch();
    },
    // 导出
    onExport() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-new',
        paramMap: {
          ...this.searchFormData.filterData,
        },
        reportName: 'productCheckListPage',
      };
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onImport() {
      this.openSubPage({
        path: '/product/productTestingReportImport',
        query: {
          fileName: '产品检测报告导入.xlsx',
          appCode: 'ec-pc-new',
        },
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0
.footerBox
  text-align right
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
    width 240px !important
>>> .date-range .single-date
  width 110px !important

>>> .form-number-input .el-input-number {
    width: 105px !important;
}
>>> .form-number-input .el-input-number .el-input {
    width: 105px !important;
}
</style>
